var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose32Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8007 8.79924L23.2007 7.19922L16.0007 14.3992L8.80068 7.19922L7.20068 8.79924L14.394 15.9992L7.20068 23.1992L8.80068 24.7992L16.0007 17.5992L23.2007 24.7992L24.8007 23.1992L17.6007 15.9992L24.8007 8.79924Z",
    fill: "#343A40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose32Line);
export default __webpack_public_path__ + "static/media/icon_close_32_line.cf42bc0d147d7b6ad44cd9b50f84c369.svg";
export { ForwardRef as ReactComponent };